/**
 * Pure checkout-handoff attribute merge (extracted verbatim from cartStore).
 * Meta-owned keys are always dropped from the existing list and replaced only
 * by the current consent-gated rebuild; Google keys follow
 * mergeGoogleCartAttributes; gift and all other attributes are preserved.
 * Removing Meta keys here does NOT revoke anything already sent server-side.
 */
import { mergeGoogleCartAttributes } from "@/lib/googleCartAttrs";
import { META_CLICK_ATTR_KEYS } from "@/lib/metaClickKeys";
import { SNAP_CLICK_ATTR_KEYS } from "@/lib/snapClickId";

export interface Attr {
  key: string;
  value: string;
}

/** Safe rebuild: a throwing optional builder yields no Meta attributes (removal). */
export function safeBuildMeta(build: () => Attr[]): Attr[] {
  try {
    return build();
  } catch {
    return [];
  }
}

export function mergeCheckoutTrackingAttributes(
  attrs: readonly Attr[],
  freshTracking: Attr[],
  ref: string,
  previousRef: string,
): Attr[] {
  const merged = mergeGoogleCartAttributes(
    attrs.filter((attr) => attr.key !== "ambassador_ref" && !META_CLICK_ATTR_KEYS.includes(attr.key) && !SNAP_CLICK_ATTR_KEYS.includes(attr.key)),
    freshTracking,
  );
  if (ref) merged.push({ key: "ambassador_ref", value: ref });
  else if (previousRef) merged.push({ key: "ambassador_ref", value: "" });
  return merged;
}
